class GlobalDataStore {
  constructor() {
    this.state = new Map();  // O(1) access
    this.subscribers = new Map();  // For reactivity
    this.subId = 0;
    this.batchTimeout = null;
  }

  // Get value
  get(key) {
    return this.state.get(key) ?? null;
  }

  // Set/add/update
  set(key, value) {
    this.state.set(key, value);
    this._notify(key);
  }

  // Delete
  delete(key) {
    if (this.state.has(key)) {
      this.state.delete(key);
      this._notify(key);
    }
  }

  // Clear all
  clear() {
    this.state.clear();
    this._notify('*');
  }

  // Subscribe for changes (reactivity)
  subscribe(key, callback) {
    const id = ++this.subId;
    const wrapped = (changedKey) => {
      if (changedKey === '*' || changedKey === key) callback(this.get(key));
    };
    this.subscribers.set(id, wrapped);
    return id;
  }

  // Unsubscribe
  unsubscribe(id) {
    this.subscribers.delete(id);
  }

  // Private: Debounced notify
  _notify(changedKey) {
    if (this.batchTimeout) clearTimeout(this.batchTimeout);
    this.batchTimeout = setTimeout(() => {
      this.subscribers.forEach(cb => cb(changedKey));
      this.batchTimeout = null;
    }, 16);
  }
}

// Singleton
const dataStore = new GlobalDataStore();
export default dataStore;
